//+1 650-555-3434	
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { message } from 'antd';
import { getAuth,signInWithPopup,GoogleAuthProvider} from "firebase/auth"; 
import {getAuthToken} from '../apis/PostData'
import $ from 'jquery';

const config = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};
const app = firebase.initializeApp(config);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({ prompt: 'select_account' });

const cleanupModalBackdrop = ({ force = false } = {}) => {
  // If any Bootstrap modal is currently open, keep its backdrop/overlay.
  // This avoids removing the dim background while the login modal is still visible.
  const anyModalOpen = document.querySelector(".modal.show") !== null;
  if (!force && anyModalOpen) return;

  $(".modal-backdrop").remove();
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
};

const signInWithGoogle = async (HideModal, t) => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    if (user && typeof HideModal === "function") {
      HideModal();
      cleanupModalBackdrop({ force: true });
      message.success(t('logged-in-successfully'));
      setTimeout(() => {
        getAuthToken(auth.currentUser);
      }, 5000);
    }
    return user;
  } catch (err) {
    if (err.code !== 'auth/popup-closed-by-user' && err.code !== 'auth/cancelled-popup-request') {
      console.error(err);
    }
    return false;
  }
};

const signInWithApple = async (HideModal, t) => {
  try {
    const provider = new firebase.auth.OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('name');
    const res = await firebase.auth().signInWithPopup(provider);
    const user = res.user;
    if (user && typeof HideModal === "function") {
      HideModal();
      cleanupModalBackdrop({ force: true });
      message.success(t('logged-in-successfully'));
      setTimeout(() => {
        getAuthToken(auth.currentUser);
      }, 5000);
    }
    return user;
  } catch (err) {
    if (err.code !== 'auth/popup-closed-by-user' && err.code !== 'auth/cancelled-popup-request') {
      console.error(err);
    }
    return false;
  }
};

export {
  auth,
  signInWithGoogle,
  signInWithApple,
  cleanupModalBackdrop,
};